// 'app/views/student/devise_passwords/new.html.erb'用の処理
export default () => {
  const studentPhone = document.getElementById('student_phone_pw_reset');
  // PWリセット申請画面でなければ終了
  // SMS非対応の学校は#student_phone_pw_resetがHTML上に無い
  if (!studentPhone) return;

  const studentEmail = document.getElementById('student_email_pw_reset');

  const disableFormEmailOrPhone = () => {
    if (studentEmail.value !== '') {
      studentPhone.disabled = true;
    } else {
      studentPhone.disabled = false;
    }

    if (studentPhone.value !== '') {
      studentEmail.disabled = true;
    } else {
      studentEmail.disabled = false;
    }
  };

  window.addEventListener('load', () => {
    disableFormEmailOrPhone();
  });

  studentPhone.addEventListener('input', () => {
    disableFormEmailOrPhone();
  });

  studentEmail.addEventListener('input', () => {
    disableFormEmailOrPhone();
  });
};
